import { render } from "./platformLao.vue?vue&type=template&id=4faa2f70&scoped=true"
import script from "./platformLao.vue?vue&type=script&lang=js"
export * from "./platformLao.vue?vue&type=script&lang=js"

import "./platformLao.vue?vue&type=style&index=0&id=4faa2f70&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faa2f70"]])

export default __exports__